/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        toggle: {
            bar: {
                borderWidth: {
                    value: "2px",
                    type: "dimension",
                },
                borderColor: {
                    value: "#949494",
                    type: "color",
                },
                backgroundColor: {
                    value: "#949494",
                    type: "color",
                },
            },
            thumb: {
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            hover: {
                bar: {
                    borderColor: {
                        value: "#676767",
                        type: "color",
                    },
                    backgroundColor: {
                        value: "#676767",
                        type: "color",
                    },
                },
            },
            focus: {
                bar: {
                    borderColor: {
                        value: "#949494",
                        type: "color",
                    },
                    backgroundColor: {
                        value: "#949494",
                        type: "color",
                    },
                    boxShadow: {
                        value: {
                            layers: [
                                {
                                    inset: false,
                                    offsetX: 0,
                                    offsetY: 0,
                                    blur: 0,
                                    spread: "1px",
                                    color: "#ffffff",
                                },
                                {
                                    inset: false,
                                    offsetX: 0,
                                    offsetY: 0,
                                    blur: 0,
                                    spread: "calc(2px + 1px)",
                                    color: "#3e95fa",
                                },
                            ],
                            stringValue: "0 0 0 1px #ffffff, 0 0 0 calc(2px + 1px) #3e95fa",
                        },
                        type: "shadow",
                    },
                },
            },
            disabled: {
                bar: {
                    borderColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
            },
            toggled: {
                bar: {
                    backgroundColor: {
                        value: "#455D82",
                        type: "color",
                    },
                    borderColor: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                hover: {
                    bar: {
                        borderColor: {
                            value: "#364262",
                            type: "color",
                        },
                        backgroundColor: {
                            value: "#364262",
                            type: "color",
                        },
                    },
                },
                focus: {
                    bar: {
                        backgroundColor: {
                            value: "#455D82",
                            type: "color",
                        },
                    },
                },
                disabled: {
                    bar: {
                        borderColor: {
                            value: "#D5E3F1",
                            type: "color",
                        },
                        backgroundColor: {
                            value: "#D5E3F1",
                            type: "color",
                        },
                    },
                },
            },
            small: {
                bar: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    width: {
                        value: "33px",
                        type: "dimension",
                    },
                },
                thumb: {
                    height: {
                        value: "10px",
                        type: "dimension",
                    },
                    width: {
                        value: "10px",
                        type: "dimension",
                    },
                },
                paddingHorizontal: {
                    value: "3px",
                    type: "dimension",
                },
            },
            large: {
                bar: {
                    height: {
                        value: "24px",
                        type: "dimension",
                    },
                    width: {
                        value: "46px",
                        type: "dimension",
                    },
                },
                thumb: {
                    height: {
                        value: "16px",
                        type: "dimension",
                    },
                    width: {
                        value: "16px",
                        type: "dimension",
                    },
                },
                paddingHorizontal: {
                    value: "4px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
